/*
 * general-note (schema)
 */
import { boolean, integer, text, timestamp, uuid } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { patients } from "../patient/patient.schema"

// generalNoteType: 0 = admin, 1 = medical
// importanceType:  0 = not important, 1 = medical, 2 = admin, 3 = file closure

export const generalNotes = schema.table("general_notes", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),

	// --- Content ---
	note: text("note").notNull(),
	noteSeen: boolean("note_seen").notNull().default(false),
	generalNoteType: integer("general_note_type").notNull().default(0),
	importanceType: integer("importance_type").notNull().default(0),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
